export default __webpack_public_path__ + "images/eec30dfac1b8d6106c85d5f5169da3e2-rudy-game-solved-header-en.svg";